module.exports = __webpack_public_path__ + "image/logo_white.png";